<template lang="pug">
#meetings-no-show-flow

  .light-gray-text.light-text
    | Em caso de "No Show" de um lead, deseja enviá-lo para um fluxo?
    br
    | Se sim, digite o nome do fluxo abaixo ou clique no campo para um selecionar um.

    .interations.row
      .col-md-6.contact-list-item-flow
        flows.field(@flow-selected="selectFlow",
                    :user_id="selected_user",
                    :default_flow="default_flow")

      .col-md-6
        button.btn.btn-primary(@click="submit") Salvar

</template>

<script>
import helpers from "../../helpers.coffee";

const view_model = {
  components: {
    flows: require("../shared/autocomplete/flows.vue")
  },
  data() {
    return {
      selected_user: Session.current_user.id,
      flow: null,
      default_flow: Session.current_user.flow.id ? Session.current_user.flow : null
    };
  },
  methods: {
    selectFlow(flow) {
      this.flow = flow.id;
    },
    submit() {
      new UsersResource().update(this.updateSuccess, this.unknownError, {
        id: this.selected_user,
        flow_id: this.flow
      });
    },
    updateSuccess(data, response) {
      Session.signIn(response.body.user);
      alertify.success("Dados salvos com sucesso!");
    }
  }
};

exports.default = helpers.vue_include(view_model, helpers.form);
</script>


<style lang="sass">
#meeting-type
  @import "../../assets/stylesheets/_variables.sass"

  input.form-control
    height: 38px

  .table-col:first-child
    padding-left: 20px

  .interations
    padding-top: 20px
    margin-bottom: 40px

  .v-autocomplete
    position: relative
    width: 100%
  .v-autocomplete-input-group
    margin-bottom: 0 !important
    width: 100%
  .contact-list-item-flow,
  .v-autocomplete-input-group
    .toggler-inline
      width: 100%
      display: flex
      flex-direction: row
      align-items: center;
    input[type=search]
      flex: 8
      height: 38px;
      border-radius: 3px;
      border: solid 1px #c4cacf
      padding-left: 8px
      width: 100% !important
    label
      margin-right: 14px
    .v-autocomplete-list
      z-index: 200
      position: absolute
      width: 100%
      text-align: left
      border-radius: 2px
      background-color: #ffffff
      border: solid 1px #e6e8ea
      margin-top: 2px
      position: absolute

      .v-autocomplete-list-item
        position: relative
        cursor: pointer
        height: 30px
        line-height: 30px !important
        background-color: #fff
        padding-left: 12px
        font-size: 12px
        text-align: justify
        color: #8d99a2

        &:hover
          background-color: $reev-base-green
          &::before
            position: absolute
            content: " "
            right: 9px
            top: calc(50% - 3.5px)
            width: 7px
            height: 7px
            background-image: url('../../assets/images/autocomplete-selection-arrow.svg')
</style>



// WEBPACK FOOTER //
// no_show_flow.vue?3228513c